import React from "react"
import { Link } from "gatsby"
import LazyImage from "../components/LazyImage"
import Low from "../images/low_gradient.png"

function Suggestions(props) {
  if (props.data.length === 0) {
    return ""
  }
  return (
    <div className="container text-center" style={{ marginTop: "10rem" }}>
      <h1 className="secret mt-5">Related Products</h1>
      <div className="row mt-4">
        {props.data.map((el, index) => (
          <Link key={el.id} to={"/product/" + el.id} class="card col-lg-4">
            <div
              className="card-elements"
              style={{
                borderImageSlice: `${Math.floor(Math.random() * 30) + 22}%`,
              }}
            >
              <LazyImage
                lowRes={Low}
                highRes={
                  el.images[0].type === "video"
                    ? el.images[1].url
                    : el.images[0].url
                }
                class="card-img-top"
                alt="..."
                style={{ height: "400px" }}
              />
              <div className="card-body">
                <h4 className="card-text secret text-accent">
                  {el.name}
                  <p
                    className="card-text text-dark"
                    style={{ fontFamily: "Lato", fontSize: 16 }}
                  >
                    {el.category}
                    <br />
                    {el.price !== el.discount_price ? (
                      <strike className="text-danger mt-2">
                        ${el.price.toFixed(1)}
                      </strike>
                    ) : (
                      ""
                    )}
                  </p>
                </h4>
              </div>
              <div className="price-tag">${el.discount_price.toFixed(1)}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}

export default Suggestions
